import React, { useState } from 'react';
import { Gift } from 'lucide-react';
import ReferProviderModal from './ReferProviderModal';

/**
 * ReferProviderChip — Mar 3, 2026
 * ---------------------------------
 * Small pill-shaped button that lives in the app header next to the user
 * menu. Opens the shared ReferProviderModal on click. Only visible when the
 * user is signed in (guest / logged-out users won't have a personal code).
 */
const ReferProviderChip = ({ user, compact = false }) => {
  const [open, setOpen] = useState(false);
  if (!user) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-1.5 rounded-full border border-amber-500/40 bg-gradient-to-r from-amber-500/15 to-primary/15 hover:from-amber-500/25 hover:to-primary/25 text-amber-200 font-semibold transition-all ${compact ? 'h-7 px-2 text-[11px]' : 'h-8 px-3 text-xs'}`}
        title="Invite a fellow provider"
        data-testid="refer-provider-chip"
      >
        <Gift className={compact ? 'w-3 h-3' : 'w-3.5 h-3.5'} />
        {compact ? 'Refer' : 'Refer a Provider'}
      </button>
      <ReferProviderModal open={open} onOpenChange={setOpen} />
    </>
  );
};

export default ReferProviderChip;
